/** Shared marketplace primitives. Keep workflow policy in its own surface. */
export function marketplaceAccessGranted(user, permission, feature) {
  if (!user) return false;
  const permissions = user.permissions || user.scopes || [];
  if (Array.isArray(permissions) && permissions.includes(permission)) return true;
  const features = user.features || user.tenant?.features || [];
  return Array.isArray(features) && features.includes(feature);
}

export function marketplaceNumber(value) {
  if (value === null || value === undefined || value === '') return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
}

export function formatUsd(amount) {
  const number = Number(amount);
  if (!Number.isFinite(number)) return '—';
  return `$${number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

/** Normalize the gateway earnings envelope before a surface adds presentation labels. */
export function summarizeMarketplaceEarnings(payload) {
  const rows = (Array.isArray(payload?.earnings) ? payload.earnings : []).map((event) => ({
    id: event.id,
    executionId: event.execution_id,
    offerSlug: event.offer_slug || null,
    basis: event.basis,
    payeeType: event.payee_type,
    amountUsd: marketplaceNumber(event.amount_usd) ?? 0,
    status: event.status,
    payoutRef: event.payout_ref || null,
    createdAt: event.created_at || null,
  }));
  const sumOf = (status) => rows.filter((row) => row.status === status)
    .reduce((total, row) => total + row.amountUsd, 0);
  const accrued = marketplaceNumber(payload?.total_accrued_usd);
  return { rows, accruedUsd: accrued === null ? sumOf('accrued') : accrued, paidUsd: sumOf('paid') };
}
